module.exports = __webpack_public_path__ + "static/media/Big_BallG.08197d15.png";